import React from "react"
import { Carousel, Modal } from "react-bootstrap"
import Img from "gatsby-image"
import './Carousel.scss';

// Declared outside MyCarousel: a component defined inside would get a new
// identity on each state change, remounting (and reloading) every image.
const CImg = ({fluid, text}) => (
  <div className="carousel-frame">
    <Img
      className="w-100"
      style={{
        left: "50%",
        transform: "translateX(-50%)"
      }}
      fluid={fluid}
      alt={text}
    />
  </div>
);

const MyCarousel = ({items, className, withModal}) => {
  const [showModal, setShowModal] = React.useState(false);
  const [modalItem, setModalItem] = React.useState(null);
  const [index, setIndex] = React.useState(0);

  const handleShowModal = (item) => {
    setModalItem(item);
    setShowModal(true);
  };

  const handleHideModal = () => {
    setModalItem(null);
    setShowModal(false);
  };

  return (
    <>
      <Carousel className={className} interval={null} activeIndex={index} onSelect={(i) => setIndex(i)}>
        {items.map((item, i) => (
          <Carousel.Item key={i}>
            {withModal && (
              <a style={{cursor: "zoom-in"}} onClick={() => handleShowModal(item)}>
                <CImg fluid={item.fluid} text={item.text}/>
              </a>
            )}
            {!withModal && (
              <CImg fluid={item.fluid} text={item.text}/>
            )}
            {item.text && (
              <Carousel.Caption className="d-none d-lg-block">
                <p>{item.text}</p>
              </Carousel.Caption>
            )}
          </Carousel.Item>
        ))}
      </Carousel>
      {/* Mobile: captions under the image, all stacked in the same cell so
          the block keeps the height of the longest one */}
      {items.some(item => item.text) && (
        <div className="carousel-captions d-lg-none">
          {items.map((item, i) => (
            <p key={i} className={i === index ? "active" : ""}>{item.text}</p>
          ))}
        </div>
      )}
      {withModal && (
        <Modal 
          className="carousel-modal"
          show={showModal}
          onHide={handleHideModal}
          dialogClassName="modal-100w"
          >
          <Modal.Header closeButton />
          <Modal.Body>
            <>
              {modalItem && (<img src={modalItem.original} alt={modalItem.text} />)}
            </>
          </Modal.Body>
        </Modal>
      )}
    </>
  )
}

MyCarousel.defaultProps = {
  withModal: false,
}

export default MyCarousel;